import { gate } from 'hub-http/gates';
import identity from 'transmute/identity';
import { getLeadSettingsRpc } from '../../../__generated__/chirp/com/hubspot/leads/rpc/LeadsSettingsRpc';
import { InMemoryCache } from '../InMemoryCache';
const fetchLeadSettingsRest = (__unusedKey, httpClient) => {
  return httpClient.get('leads/v3/settings');
};
const fetchLeadSettings = rpcClient => {
  return rpcClient.call(getLeadSettingsRpc, {
    request: undefined
  }).then(response => response.settings);
};
export const makeLeadSettingsCache = () => new InMemoryCache('LeadSettingsCache', identity, ({
  httpClient,
  rpcClient,
  getIsUngated
}) => key => getIsUngated(gate('CRM:Properties:LeadSettingsChirp')) ? fetchLeadSettings(rpcClient) : fetchLeadSettingsRest(key, httpClient));